<template>
  <div>
    <h2>Tubulação</h2>
    <form action="" class="md-layout" @submit.prevent="submit">
      <div class="md-layout-item md-size-100">
        <label class="md-subheading" for="color">Cor</label>
        <compact v-model="color" />
      </div>

      <md-field class="md-layout-item md-size-100">
        <label for="thickness">Espessura</label>
        <md-input
          id="thickness"
          v-model.number="thickness"
          type="number"
          min="1"
        />
      </md-field>

      <md-field class="md-layout-item md-size-100">
        <label for="arrow">Seta</label>
        <md-select id="arrow" v-model="arrow">
          <md-option :value="PipeArrowDirection.None"> Nenhuma </md-option>
          <md-option :value="PipeArrowDirection.Forward">
            Para frente
          </md-option>
          <md-option :value="PipeArrowDirection.Backward">
            Para trás
          </md-option>
          <md-option :value="PipeArrowDirection.Both"> Ambas </md-option>
        </md-select>
      </md-field>

      <div class="md-layout-item md-size-100">
        <md-switch v-model="flatColor">Cor plana</md-switch>
      </div>

      <md-field v-if="flatColor" class="md-layout-item md-size-100">
        <label for="borderThickness">Espessura da borda (%)</label>
        <md-input
          id="borderThickness"
          v-model.number="borderThicknessPercent"
          type="number"
          min="0"
          max="50"
        />
      </md-field>

      <div style="text-align: right; width: 100%">
        <md-button class="md-raised md-accent" @click="() => $emit('close')">
          Cancelar
        </md-button>
        <md-button type="submit" class="md-raised md-primary">
          Editar
        </md-button>
      </div>
    </form>
  </div>
</template>

<script>
import Compact from 'vue-color/src/components/Compact.vue'

import { PipeArrowDirection } from '@/utils/componente'
import http from '@/utils/http'

export default {
  name: 'ViewPipeForm',
  components: {
    Compact,
  },
  props: {
    localId: {
      type: String,
      required: true,
    },
    viewId: {
      type: String,
      required: true,
    },
    componente: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      PipeArrowDirection,
      color: '#6b7280',
      thickness: 12,
      arrow: PipeArrowDirection.None,
      flatColor: true,
      borderThicknessPercent: 20,
    }
  },
  beforeMount() {
    const value = (this.componente && this.componente.value) || {}
    this.color = value.color || this.color
    this.thickness = value.thickness > 0 ? value.thickness : this.thickness
    this.arrow = value.arrow != null ? value.arrow : this.arrow
    this.flatColor = value.flatColor != null ? value.flatColor : this.flatColor
    this.borderThicknessPercent =
      value.borderThicknessPercent != null
        ? value.borderThicknessPercent
        : this.borderThicknessPercent
  },
  methods: {
    async submit() {
      if (!this.componente) return

      // Preserva os pontos e demais campos existentes; altera apenas o estilo.
      const value = {
        ...this.componente.value,
        color: typeof this.color === 'string' ? this.color : this.color.hex,
        thickness: Math.max(1, this.thickness || 1),
        arrow: this.arrow,
        flatColor: this.flatColor,
        borderThicknessPercent: Math.min(
          50,
          Math.max(0, this.borderThicknessPercent || 0)
        ),
      }

      const response = await http.put(`/view/componente`, {
        id: this.componente.id,
        z: this.componente.z,
        value,
      })

      if (response) {
        this.$emit('close')
        this.$emit('updated')
      }
    },
  },
}
</script>

<style scoped></style>
